import { APICore } from "./apiCore";

const api = new APICore();

// category
function getPayoutsApi(influencer_id: any, type?: any, from?: any, to?: any) {
  const baseUrl = "/influencer-payouts";

  const params: any = {
    id: influencer_id,
  };

  if (type) params.type = type;
  if (from) params.from = from;
  if (to) params.to = to;

  return api.get(`${baseUrl}`, params);
}

function getPayoutsDetailsApi(influencer_id: any, from?: any, to?: any) {
  const baseUrl = "/payout-details";

  const params: any = {
    id: influencer_id,
  };

  if (from) params.start = from;
  if (to) params.end = to;

  return api.get(`${baseUrl}`, params);
}

export { getPayoutsApi, getPayoutsDetailsApi };
